// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9UguW","rootNoMargin":"styles_rootNoMargin__p7_C7"};